import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import PropTypes from 'prop-types'
import Trans from 'next-translate/Trans'
import { useQuery } from '@apollo/client'

import styles from './style.module.scss'

import Error from '@shared/components/error'
import CustomSelect from '@shared/components/customSelect'
import CustomSearch from '@shared/components/customForm/customSearch'
import MyImage from '@shared/components/myImage'
import ball from '@assets/images/icon/ball-icon.svg'
import bat from '@assets/images/icon/bat-icon.svg'
import wc from '@assets/images/icon/wc-icon.svg'
import allr from '@assets/images/icon/allr-icon.svg'
import { GET_AUCTION_FILTER_DATA } from '@graphql/ipl-auction/ipl-auction-players-filter'
import { DownloadV2Icon, FilterIcon } from '@shared/components/ctIcons'
import CtToolTip from '@shared/components/ctToolTip'
import { S3_PREFIX } from '@shared/constants'

const AuctionFilter = ({ data, seoData, handleSearch, handleFilter, category, payload }) => {
  const [isOpen, setIsOpen] = useState(false)
  const sortOptions = [
    { sValue: 'Final Price 0-9', sLabel: 'Final Price 0-9' },
    { sValue: 'Final Price 9-0', sLabel: 'Final Price 9-0' }
  ]
  const statusOptions = [
    { sValue: 's', sLabel: 'Sold' },
    { sValue: 'us', sLabel: 'UnSold' },
    { sValue: 't', sLabel: 'Transferred' },
    { sValue: 'r', sLabel: 'Retained' }
    // { sValue: 'b', sLabel: 'Bidding' },
    // { sValue: 'rtm', sLabel: 'RTM' }
  ]
  const capped = [
    { sLabel: 'Capped', sValue: true },
    { sLabel: 'Uncapped', sValue: false }
  ]

  const [countryOptions, setCountryOptions] = useState([])
  const [teamOptions, setTeamOptions] = useState([])

  useQuery(GET_AUCTION_FILTER_DATA, {
    variables: { input: { iAuctionSeriesId: category?.data?.oAuctionSeries?._id } },
    onCompleted: (data) => {
      if (data && data.listAuctionFilterData) {
        const tempCountryOptions = data.listAuctionFilterData.aAuctionPlayerCountry?.map((country) => {
          return {
            sLabel: country?.sAbbr || country?.sTitle,
            sValue: country?._id
          }
        })
        setCountryOptions(tempCountryOptions)
        const tempTeamOptions = data.listAuctionFilterData.aAuctionPlayerTeam?.map((team) => {
          return {
            sLabel: team?.oTeam?.sAbbr || team?.oTeam?.sTitle,
            sValue: team?.oTeam?._id
          }
        })
        setTeamOptions(tempTeamOptions)
      }
    }
  })

  return (
    <>
      <div className="d-flex gap-2 mb-2 align-items-center">
        <CustomSearch placeholder="Search by Player" className="mb-0 flex-grow-1" inputClass="py-2" onChange={handleSearch} />
        <Button className={`theme-btn small-btn d-xl-none ${styles.filterBtn}`} onClick={() => setIsOpen(true)}>
          <FilterIcon />
        </Button>
        {category?.data?.oAuctionSeries?.sPDFUrl && (
          <a
            href={S3_PREFIX + category?.data?.oAuctionSeries?.sPDFUrl}
            target="_blank"
            className="theme-btn small-btn outline-btn flex-shrink-0 d-flex align-items-center"
            rel="nofollow noreferrer"
          >
            <span style={{ width: 20, display: 'inline-block' }} className="me-1">
              <DownloadV2Icon />
            </span>
            PDF
          </a>
        )}
      </div>
      <div className={`${styles.mobFixtureFilter} ${isOpen && styles.active} light-bg p-xl-2 my-xl-2`}>
        <div className={`${styles.head} d-flex d-xl-none justify-content-between align-items-center`}>
          <p className="font-semi mb-0">
            <Trans i18nKey="common:Filter" />
          </p>
          <Button variant="link" onClick={() => setIsOpen(false)} className="btn-close"></Button>
        </div>
        <div className={`${styles.innerBlock}`}>
          <div className={`${styles.filter} d-flex align-items-lg-center flex-column flex-lg-row gap-2`}>
            <CustomSelect
              options={teamOptions}
              labelKey="sLabel"
              valueKey="sValue"
              placeholder="Team"
              value={payload?.iTeamId ? teamOptions?.find((e) => e?.sValue === payload?.iTeamId) : { sLabel: 'Team' }}
              onChange={(e) => handleFilter({ iTeamId: e?.sValue })}
              isNative
            />
            <CustomSelect
              options={statusOptions}
              labelKey="sLabel"
              valueKey="sValue"
              placeholder="Status"
              value={payload?.eAuctionStatus ? statusOptions?.find((e) => e?.sValue === payload?.eAuctionStatus) : { sLabel: 'Status' }}
              onChange={(e) => handleFilter({ eAuctionStatus: e?.sValue })}
              isNative
            />
            <CustomSelect
              options={countryOptions}
              labelKey="sLabel"
              valueKey="sValue"
              placeholder="Country"
              value={payload?.iCountryId ? countryOptions?.find((e) => e?.sValue === payload?.iCountryId) : { sLabel: 'Country' }}
              onChange={(e) => handleFilter({ iCountryId: e?.sValue })}
              isNative
            />
            <CustomSelect
              options={sortOptions}
              labelKey="sLabel"
              valueKey="sValue"
              placeholder="Sort"
              value={
                payload?.nOrder && payload?.sSortBy === 'nSoldPrice' ? payload?.nOrder === 1 ? sortOptions?.[0] : sortOptions?.[1] : { sLabel: 'Sort' }
              }
              onChange={(e) => handleFilter({ sort: e?.sValue })}
              isNative
            />
            <CustomSelect
              options={capped}
              labelKey="sLabel"
              valueKey="sValue"
              placeholder="Cap"
              // value={{ sLabel: 'Uncapped', sValue: false }}
              // value={typeof payload?.bCappedPlayer === 'boolean' ? capped?.find(e => e?.sValue === payload?.bCappedPlayer) : null}
              // value={payload?.nOrder ? (payload?.nOrder === 1 ? sortOptions?.[0] : sortOptions?.[1]) : { sLabel: 'Sort' }}
              onChange={(e) => handleFilter({ bCappedPlayer: e?.sValue === true })}
              isNative
              isValueBoolean
            />
            {/* {console.log(capped?.find(e => e?.sValue === payload?.bCappedPlayer))} */}
            <div className={`${styles.role} d-flex align-items-center justify-content-between my-2 my-lg-0`}>
              <p className="small-text text-uppercase text-medium mb-0 light-text font-semi">Role</p>
              <CtToolTip tooltip="Batter">
                <Button
                  variant="link"
                  className={`flex-flex-shrink-0 br-sm ${payload?.sPlayingRole === 'bat' && styles.active}`}
                  onClick={() => handleFilter({ sPlayingRole: 'bat' })}
                >
                  <MyImage src={bat} alt="icon" />
                </Button>
              </CtToolTip>
              <CtToolTip tooltip="Bowler">
                <Button
                  variant="link"
                  className={`flex-flex-shrink-0 br-sm ${payload?.sPlayingRole === 'bowl' && styles.active}`}
                  onClick={() => handleFilter({ sPlayingRole: 'bowl' })}
                >
                  <MyImage src={ball} alt="icon" />
                </Button>
              </CtToolTip>
              <CtToolTip tooltip="Wicket Keeper">
                <Button
                  variant="link"
                  className={`flex-flex-shrink-0 br-sm ${payload?.sPlayingRole === 'wk' && styles.active}`}
                  onClick={() => handleFilter({ sPlayingRole: 'wk' })}
                >
                  <MyImage src={wc} alt="icon" />
                </Button>
              </CtToolTip>
              <CtToolTip tooltip="All Rounder">
                <Button
                  variant="link"
                  className={`flex-flex-shrink-0 br-sm ${payload?.sPlayingRole === 'all' && styles.active}`}
                  onClick={() => handleFilter({ sPlayingRole: 'all' })}
                >
                  <MyImage src={allr} alt="icon" />
                </Button>
              </CtToolTip>
              {/* <label className={`${styles.switch} ms-auto mx-lg-1`}>
                <input
                  type="checkbox"
                  checked={payload?.bCappedPlayer}
                  onChange={(e) => {
                    handleFilter({ bCappedPlayer: e?.target?.checked })
                  }}
                />
                <span className={`${styles.slider} position-relative rounded-pill`}></span>
                <span className={`${styles.labeltext} light-text text-uppercase font-semi small-text`}>Capped</span>
              </label> */}
            </div>
            <div className="d-flex justify-content-around gap-2">
              <Button className="theme-btn small-btn outline-btn mt-2 mt-xl-0 flex-grow-1" onClick={() => handleFilter()}>
                <Trans i18nKey="common:Clear" />
              </Button>
              <Button className="theme-btn small-btn btn-primary mt-2 mt-xl-0 d-xl-none flex-grow-1" onClick={() => setIsOpen(false)}>
                Apply
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

AuctionFilter.propTypes = {
  data: PropTypes.object,
  seoData: PropTypes.object,
  payload: PropTypes.object,
  category: PropTypes.object,
  handleSearch: PropTypes.func,
  handleFilter: PropTypes.func
}

export default Error(AuctionFilter)
